import { create } from "zustand";
import { persist, createJSONStorage } from "zustand/middleware";
import * as Sentry from "@sentry/react";
import { IS_PRODUCTION } from "@/utils/env";
import { jwtDecode } from "jwt-decode";

interface LoginState {
  token: string | null;
  isAuthenticated: boolean;
  setToken: (token: string) => void;
  clearToken: () => void;
}

// JWT 토큰에서 사용자 정보 추출용 인터페이스
interface DecodedToken {
  id: string;
  email: string;
  name?: string;
  role: string;
  exp: number;
}

const useLoginStore = create<LoginState>()(
  persist(
    (set) => ({
      token: null,
      isAuthenticated: false,
      setToken: (token: string) => {
        set({ token, isAuthenticated: true });

        // 프로덕션 환경에서만 Sentry에 사용자 정보 설정
        if (IS_PRODUCTION) {
          try {
            const decoded = jwtDecode<DecodedToken>(token);
            Sentry.setUser({
              id: decoded.id,
              email: decoded.email,
              username: decoded.name || decoded.email,
              role: decoded.role,
            });
          } catch (error) {
            console.error("Failed to decode token for Sentry:", error);
          }
        }
      },
      clearToken: () => {
        set({ token: null, isAuthenticated: false });

        // 프로덕션 환경에서만 Sentry 사용자 정보 클리어
        if (IS_PRODUCTION) {
          Sentry.setUser(null);
        }
      },
    }),
    {
      name: "auth-storage", // 로컬 스토리지에 저장될 이름
      storage: createJSONStorage(() => localStorage),
    }
  )
);

export default useLoginStore;
